export default "__VITE_ASSET__CslikCnB__"